










































































































import { DetailItem } from "@/store/telegram_otp/statistic/types";
import { Component } from "vue-property-decorator";
import { Getter } from "vuex-class";
import {LongTextWings, ScrollButton} from 'wings-ui-components';
import BaseItemsPage from "@/pages/Pages/BaseItemsPage";
import TelegramOtpDetailFilter from "@/components/TelegramOtp/TelegramOtpDetailFilter.vue";
import { dateFilter } from "@/utils/date-util";

@Component({ components: {TelegramOtpDetailFilter, ScrollButton, LongTextWings}, filters: {dateFilter} })
export default class TelegramOtpDetail extends BaseItemsPage<DetailItem> {

  @Getter("telegramOtpStatisticDetail") responseItems: any;

  is_show_filter_additional = false;
  currentSort = "create_date";

  tableFields = this.tableFieldsDefault;

  get tableFieldsDefault() {
    return [
      "create_date",
      "originator",
      "recipient",
      "status",
      "partner_price",
      "detail"
    ];
  }

  getData() {
    return this.responseItems;
  }

}
